import React, { useState } from 'react'
import { IBasePicker, ITag } from 'office-ui-fabric-react'
import { TagInput } from '../../../../Components/Input/TagInput'
import { SellersComboBox } from './SellersComboBox'
import { Seller } from '../../../../Api/schain'
import { Reference } from '../../../../Api/references'

interface AddReferencesFormProps {
  suggestedBuyerDomains: string[]
  previousNode: {
    label: string
    domain?: string
  }
  onReference: (reference: Reference) => void
}

export const AddReferencesForm: React.FC<AddReferencesFormProps> = ({
  suggestedBuyerDomains,
  previousNode,
  onReference,
}) => {
  const [buyerDomain, setBuyerdomain] = useState<string | null>(null)
  const [seller, setSeller] = useState<Seller | null>(null)
  const [tagInputComponentRef, setTagInputComponentRef] =
    useState<IBasePicker<ITag> | null>(null)
  return (
    <>
      <TagInput
        label={`3rd party sellers.json domain containing "${previousNode.label}"`}
        itemLimit={1}
        selectedItems={
          buyerDomain ? [{ key: buyerDomain, name: buyerDomain }] : []
        }
        onChange={(value: ITag[] = []) => {
          const newBuyerDomain = value.length ? value[0].key : null
          setBuyerdomain(newBuyerDomain)
          setSeller(null)
        }}
        onResolveSuggestions={(domain): ITag[] => {
          const suggestions: ITag[] = []
          suggestedBuyerDomains.forEach((domain) => {
            suggestions.push({
              key: domain,
              name: domain,
            })
          })
          if (domain) {
            suggestions.unshift({
              key: domain,
              name: `Connect to "${domain}"`,
            })
          }
          return suggestions
        }}
        pickerLabels={{ suggestionsHeader: '', noResults: '' }}
        required
        componentRef={(ref) => {
          if (!ref) {
            return
          }
          setTagInputComponentRef(ref)
        }}
        onBlur={() => {
          if (buyerDomain || !tagInputComponentRef) {
            return
          }
          tagInputComponentRef.completeSuggestion(true)
        }}
      />
      <SellersComboBox
        domain={buyerDomain || ''}
        disabled={!buyerDomain}
        onChange={({ seller }) => {
          setSeller(seller || null)
          if (buyerDomain && seller) {
            onReference({
              buyerDomain,
              ...seller,
            })
          }
        }}
        selectedSellerId={seller ? seller.seller_id : ''}
        previousNode={previousNode}
        label={`Business entity representing "${previousNode.label}"`}
      />
    </>
  )
}

export default AddReferencesForm
